<template>
  <div class="field-item row" style="width: 470px !important;">
    <div class="col-md-6">
      <span class="item-label" v-if="showFieldLabel">{{ label }}:</span>
    </div>
    <div class="col-md-6 values">
      <span v-for="(field, i) in [sortedFields[0]]" :key="i">
        <el-tooltip placement="bottom" effect="light">
          <div slot="content">
            <strong>Confirmations:</strong>
            {{ getFieldValue(field).confirmations }}
            <br />
            <strong>Score:</strong>
            {{ getFieldValue(field).score.toFixed(2) }}
          </div>
          <span
            @click="showNuggetOptions(getFieldValue(field).value)"
            v-if="getFieldLabel(field) && !Array.isArray(getFieldValue(field).value) && field !== null"
          >
            <el-tag size="small" class="item-value">
              {{
              field && field.hasOwnProperty('friendly_value')
              ? field.friendly_value
              : findLangaugeNameFromKey(getFieldValue(field).value).includes('N/A')
              ? getFieldValue(field).value
              : findLangaugeNameFromKey(getFieldValue(field).value)
              }}
            </el-tag>
          </span>
          <span v-if="Array.isArray(getFieldValue(field).value)">
            <span
              v-for="value in getFieldValue(field).value"
              :key="value"
              @click="showNuggetOptions(value)"
              size="small"
              class="item-value"
              :style="{
                'background-color': scoreColor(getFieldValue(field).value, field),
              }"
            >{{ value }}</span>
          </span>
        </el-tooltip>
      </span>
      <span @click="handleOpenProfileMap" v-if="label === 'Location'" class="location-marker">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
      </span>
    </div>
    <NuggetOptions
      :show="optionsVisible"
      :nuggetValue="selectedNuggetValue"
      :nuggetLabel="label"
      :nuggetKey="fieldKey"
      :category="category"
      :profileId="profileId"
      @closeDialog="closeOptionsDialog"
      @removeNugget="cfg => $emit('removeNugget', cfg)"
      @blacklistNugget="cfg => $emit('blacklistNugget', cfg)"
    />
  </div>
</template>

<script>
import findLangaugeNameFromKey from '@/helpers/lang';
import { getColourCode } from './profileUtils';
import NuggetOptions from './ProfileNuggetOptionsDialog';

export default {
  name: 'ProfileDetailFieldItem',
  components: {
    NuggetOptions,
  },
  props: {
    fieldKey: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: () => [],
    },
    category: {
      type: String,
      default: '',
    },
    profileId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    optionsVisible: false,
    selectedNuggetValue: '',
    formattedProfileFields: {
      mobile_number: '',
      email: '',
      gender: '',
    },
    showFieldLabel: false,
  }),
  computed: {
    sortedFields() {
      return [...this.fields].sort((a, b) => b.score - a.score);
    },

    label() {
      return this.formatFieldName(this.fieldKey);
    },
  },

  methods: {
    getFieldLabel(field) {
      this.showFieldLabel = true;
      return Object.keys(field).length ? this.showFieldLabel : false;
    },
    findLangaugeNameFromKey,
    handleOpenProfileMap() {
      this.$emit('onShowProfileMap');
    },
    capitalise(content) {
      return content
        .split(' ')
        .map(x => `${x[0].toUpperCase()}${x.slice(1)}`)
        .join(' ');
    },

    scoreColor(score, field) {
      return field ? getColourCode(score, field.discovered_by[0]) : '';
    },

    formatFieldName(text) {
      return `${text[0].toUpperCase()}${text.slice(1)}`.replace('_', ' ');
    },

    showNuggetOptions(value) {
      this.selectedNuggetValue = value;
      this.optionsVisible = true;
    },

    closeOptionsDialog() {
      this.selectedNuggetValue = '';
      this.optionsVisible = false;
    },

    getFieldValue(field) {
      if (field) {
        const { value, confirmations, score } = field;
        return { value, confirmations, score };
      }
      return { value: 'unknown', confirmations: 1, score: 1 };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.item-label {
  color: $text-color;
  font-weight: bold;
  display: inline-block;
  text-align: right;
  width: 100%;
}

.item-input {
  display: inline-block;
  width: 55%;
}

$striped-color: rgb(240, 240, 240);

.field-item {
  font-size: 1.05em;
  margin: 10px auto;
  padding-bottom: 10px;
  border-bottom: 0.1px solid $striped-color;
}

.values {
  display: inline-block;
}
.location-marker {
  font-size: 22px;
  float: right;
  cursor: pointer;
}
.item-value {
  margin: 2px 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ProfileDetailFieldItem.vue?1f467e48